import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { BuyToneRequest } from '../api/tune/buytune/buytonerequest';
import {BuyToneBuilder} from '../dto/buytone/buytonebuilder';
import { BuyToneResponse, BuyToneResponseDtoImpl } from '../api/tune/buytune/buytoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class BuyToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<BuyToneRequest, BuyToneResponse>
{
    private packName:any;
    execute(request: BuyToneRequest): void 
    {
        this.packName = request.getBuyToneRequest().getPackName();
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            console.log("----------success");

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, 
                    this.getContext().getResources().getString(Strings.your_order_is_successfully_completed));
                    
                  new BuyToneBuilder(this.packName, this.getContext()).buildAll();
                   
                this.getAPISuccess(response);
               
              
            }
        }
        catch (e) {
            
            console.log("----------failure");
            this.getAPIFailure(new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
  
        this.getAPIFailure(new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, responseMapper.getStatusMsg()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/buytoneapiprocessor.tsx